import type { WorkScheduleWeek } from '@trinnvis/dabih-api-client';
import { defaultWorkStartTime } from './default-work-start-time';
import { defaultWorkEndTime } from './default-work-end-time';

export const defaultWorkWeek: WorkScheduleWeek = {
  monday: { workDay: true, start: defaultWorkStartTime, end: defaultWorkEndTime },
  tuesday: { workDay: true, start: defaultWorkStartTime, end: defaultWorkEndTime },
  wednesday: { workDay: true, start: defaultWorkStartTime, end: defaultWorkEndTime },
  thursday: { workDay: true, start: defaultWorkStartTime, end: defaultWorkEndTime },
  friday: { workDay: true, start: defaultWorkStartTime, end: defaultWorkEndTime },
  saturday: { workDay: false, start: defaultWorkStartTime, end: defaultWorkEndTime },
  sunday: { workDay: false, start: defaultWorkStartTime, end: defaultWorkEndTime },
};
